import axios from 'axios';
import { RISK_CONTROL } from '../common/constant';
import { riskCodes } from '../common/enum';

export const baseUrl = process.env.NODE_ENV === "development" ? process.env.MAIL_APP_BASE_URL_LOCAL : process.env.MAIL_APP_BASE_URL;

const checkResponse = (response: any) => {
    if (response.status >= 200 && response.status < 400) {
        // 触发了风控相关问题，跳转到风控错误结果页
        if (riskCodes.includes(response?.data?.code)) {
            window.location.hash = `#/result?status=${RISK_CONTROL}&riskText=${encodeURI(response?.data?.desc || '')}&noAutoLink=1`
        }
        return response.data
    }
    const error = new Error(response);
    throw error
}

const handleError = (err: any) => {
    // 网络错误统一处理
    console.error(err);
    // 返回通用码
    return {
        code: -9999
    };
}

export const get = (url: string, params: any = {}) => {
    return axios.get(baseUrl + url, { params })
        .then(checkResponse)
        .catch(handleError)
}

export const post = (url: string, params = {}) => {
    return axios.post(baseUrl + url, {...params})
    .then(checkResponse)
    .catch(handleError)
}

export const upload = (url: string, formData: FormData) => {
    return axios.post(baseUrl + url, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
    .then(checkResponse)
    .catch(handleError)
}

export const getRepairAccount = () => {
    return get('/fapi/userInfo');
}


export const getAreaCode = () => {
    return get('/area/code');
}

export const getVipRequireIfBusy = () => {
    return axios.get(baseUrl?.replace('acrepair', 'mailsrv-acrepair') + '/nie/queryServiceState.do')
    .then(checkResponse)
    .catch(handleError)
}

export const getDataGuide = (dataItem: string[]) => {
    return post('/fapi/getDataGuide', { dataItems: dataItem })
}


export const getPhoneVerifyMethod = (phone: string) => {
    return get('/sms/method', { phone })
}

export const getStaticSmsCode = () => {
    return axios.get("https://mimg.127.net/cross/static/sms.gateway/sms.config");
}